<div class="container-md">
  <div class="row">
    <div class="col-12">
      <h3 id="{{category.name + 'Id'}}"
          class="h5 fw-bold category-name border-bottom category-name-delimiter mb-0 pb-3 notranslate">
        {{ category.name }}
      </h3>
    </div>
  </div>
</div>

<div class="container-md">
  <div class="row">
    <div class="col-12">
      <table class="table treatment-table">
        <tbody>
          <tr *ngFor="let treatment of category.treatments; let treatmentIndex = index"
              [ngClass]="{ 'border-bottom py-2' : isOnlineBookingTurnedOn, 'border-bottom py-2 lh-lg' : !isOnlineBookingTurnedOn }"
              tabindex="0">
            <th scope="row"
                class="treatment-name-col border-top-0 px-0 px-lg-3 align-middle">
              <div class="notranslate">
                {{ treatment.name }}
              </div>
              <a href="#"
                 *ngIf="treatment.description"
                 class="fw-normal text-secondary"
                 [translate]="'SALON-DETAILS.SHOW-TREATMENT-DESCRIPTION'"
                 (click)="showTreatmentDescription(treatment); false"></a>
            </th>
            <td class="treatment-duration-col text-secondary text-end border-top-0 align-middle">
              <span *ngIf="treatment.isDurationVisibleForOnlineBooking">
                {{ treatment.durationInMinutes }}{{ 'SHARED.TIME-UNITS-ABBREV.MINUTES' | translate }}
              </span>
            </td>
            <td class="treatment-price-col text-secondary fw-bold text-end border-top-0 align-middle">
              <div *ngIf="treatment.price"
                   class="d-flex flex-column flex-md-row justify-content-end">
                <span class="me-md-2 text-dark"
                      *ngIf="treatment.isPriceInaccurate && treatment.isPriceVisibleForOnlineBooking"
                      [translate]="'SALON-DETAILS.PRICE-FROM'"></span>
                <span *ngIf="treatment.isPriceVisibleForOnlineBooking">{{ treatment.price | currency:'EUR' }}</span>
              </div>
              <div class="d-flex flex-column flex-md-row justify-content-end"
                   *ngIf="treatment.mandatoryDownPayment === downPaymentType.DownPaymentOnly ||
                   treatment.mandatoryDownPayment === downPaymentType.DownPaymentAndFullPrice">
                <small *ngIf="isOnlineBookingTurnedOn"
                       class="fst-italic fw-bold">
                  <span [translate]="'SALON-DETAILS.PREPAID-REQUIRED'"></span>
                </small>
              </div>
            </td>
            <td *ngIf="isOnlineBookingTurnedOn && !isMultipleTreatmentsBookingTurnedOn"
                class="text-end border-top-0 px-0 px-lg-3 align-middle">
              <button class="btn btn-primary notranslate"
                      [translate]="'SALON-DETAILS.BUTTON-BOOK'"
                      (click)="bookTreatment(treatment)"></button>
            </td>
            <td *ngIf="isOnlineBookingTurnedOn && isMultipleTreatmentsBookingTurnedOn"
                class="text-end border-top-0 px-0 px-lg-3 align-middle">
              <input type="checkbox"
                     class="d-none"
                     id="btn-check-{{categoryIndex}}-{{treatmentIndex}}"
                     autocomplete="off"
                     [(ngModel)]="treatment.isChecked"
                     (change)="bookMultipleTreatments($event, treatment)">
              <label class="btn"
                     id="btn-width"
                     [ngClass]="treatment.isChecked ? 'btn-primary border-2 px-0' : 'btn-outline-primary border-2 px-0'"
                     for="btn-check-{{categoryIndex}}-{{treatmentIndex}}">
                {{treatment.isChecked ? ('SALON-DETAILS.MULTIPLE-TREATMENTS-BUTTONS.SELECTED' | translate) : ('SALON-DETAILS.MULTIPLE-TREATMENTS-BUTTONS.SELECT' | translate) }}
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
